import {
    ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_SUCCESS,
    ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
    LOADING_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
    RESET_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED,
    NETWORK_ERROR_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED:
            return (state = initialState);
        default:
            return state;
    }
};
